import React from 'react';

import LootboxPoolsApi from '../../../../Api/CRM/Modules/Lootbox/LootboxPoolsApi';
import GetLootboxPoolResponse from '../../../../Api/CRM/Responses/Lootbox/LootboxPoolResponse';
import LootboxPoolResponse from '../../../../Api/CRM/Responses/Lootbox/LootboxPoolResponse';
import * as formatters from '../../../../utils/formatters';
import Search from '../../../elements/Search';
import BooleanIcon from '../../../elements/booleanIcon';
import Card from '../../../elements/common/Card';
import FilterByColumn, { Filter } from '../../../elements/common/FilterByColumn';
import SortButton from '../../../elements/common/SortButton';
import { TableCell as Cell } from '../../../elements/common/TableDetailsRow';
import TableHead from '../../../elements/common/TableHead';
import TableLoader from '../../../elements/common/TableLoader';
import Paginator from '../../../elements/paginator';
import useAutoPaginator from '../../../hooks/useAutoPaginator';

function LootboxPoolsPage() {
    const { items, isLoading, auto } = useAutoPaginator<GetLootboxPoolResponse>((page, params) =>
        LootboxPoolsApi.getAll(page, { params })
    );

    return (
        <Card title="All Lootbox Pools">
            <Search {...auto.search} />
            <FilterByColumn {...auto.filter}>
                <Filter column="created_at" label="Created at" type="dateRange" />
            </FilterByColumn>
            <TableLoader isLoading={isLoading}>
                <table className="table model-list">
                    <TableHead>
                        <th>Lootbox id</th>
                        <th>Is open</th>
                        <th>Trng hash</th>
                        <th>Items Count (left/total)</th>
                        <SortButton column="closed_at" order="desc" {...auto.sort} />
                        <SortButton column="created_at" order="desc" {...auto.sort} />
                    </TableHead>
                    <LootboxPoolsListTableBody lootboxPools={items} />
                </table>
                <Paginator {...auto.paginator} />
            </TableLoader>
        </Card>
    );
}

function LootboxPoolsListTableBody({ lootboxPools }: { lootboxPools: LootboxPoolResponse[] }) {
    const { formatDateStringWithTimezone } = formatters;

    return (
        <tbody>
            {lootboxPools.map((lootboxPool) => (
                <tr key={lootboxPool.id}>
                    <td>{lootboxPool.lootbox_id}</td>
                    <td>
                        <BooleanIcon value={lootboxPool.is_open} />
                    </td>
                    <td>{lootboxPool.trng_hash}</td>
                    <td>{`${lootboxPool.items_left_count} / ${lootboxPool.items_count} `}</td>
                    <Cell>{formatDateStringWithTimezone(lootboxPool.closed_at)}</Cell>
                    <Cell>{formatDateStringWithTimezone(lootboxPool.created_at)}</Cell>
                </tr>
            ))}
        </tbody>
    );
}

export default LootboxPoolsPage;
